export default __webpack_public_path__ + "static/media/sub_notification.794e934c.ogg";